import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Title } from "@vds/typography";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  CVAPP_CAMERAADJUSTMENT,
  CVAPP_OBJECTBLUR,
} from "../../../global/constants/cvappConstants";
import { hasPermission } from "../../../global/utility/permissionUtils";
import { transformPolygonData } from "../../../global/utility/roiUtils";
import DisplayCanvas from "../../../polygonLib/displayPolygonLib/displayCanvas";
import {
  clearAdvancedConfigAppearances,
  deleteRoiRequest,
  resetRoi,
  showNotificationBanner,
  unsubscribeObjectBlurringRoiRequest,
  deleteBulkUnsubscribeRoiRequest,
  successDeleteRoi,
  getAllRoiListWithCvApps,
} from "../../../store/actions";
import { adjustPolygonPoints } from "../../../utils";
import "../roi.css";
import { Notification } from "@vds/notifications";
import { cvAppBulkUndeployApi, getRulesByDeviceId } from "../../../api/RoiServiceManager";
import SnapshotComponent from "../../CameraOnboarding/SnapshotComponent";
import { isRoiWithDeployedStatus } from "../../../global/utility/statisticsUtil";
import { Tooltip } from "@mui/material";
import { Loader } from "@vds/loaders";
import { BANNER_TYPES } from "../../../global/constants/constants";
import { useWindowSize } from "../../../global/hooks/viewportHooks";
import { breakpoints } from "../../../styles/breakpoints";
import {
  LICENSE_NOTIFICATION_MESSAGES,
  LICENSE_NOTIFICATION_TYPES,
  ORIGIN_PAGES,
  ROI_NOTIFICATION_TYPES,
  UNSUBSCRIBE_FLOW_TEXTS,
  getActiveLicenseSku
} from "../../../global/constants/licensesConstants";
import { TextEllipsis } from "../../../global/components/events/styles";
import { deploymentstatusList } from "../../../global/utility/statisticsUtil";
import { DEPLOYMENT_STATUS } from "../../Polygon/constants";
import { deleteRule, deleteBulkRule } from "../../../model/ruleService";
const StyledPlusIconDiv = styled.div`
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  background-color: #eef1f1;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  cursor: pointer;
`;

const StyledIcon = styled(Icon)`
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  width: 20px;
  height: 20px;
`;

const StyledIconsET = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 50%;
  padding: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
  transition: 0.3s;
  margin-right: 5px;
`;

const RoiList = (props) => {
  const {
    filteredAppList,
    showModal,
    activeFOVTab,
    cameraData,
    streamData,
    setShowModal,
    FOVName,
    snapshot,
    setRoiData,
    roiData,
    setSelectedRoi,
    selectedRoi,
    roiIds,
    setRoiIds,
    FOVSnapshot,
    fieldOfViews,
    state,
    onDelete,
    onEdit,
    setFloorImage,
    floorImage,
    showLoader,
    refreshRoi,
    isLicenseSuspended,
    setDeleteBannerNotification,
    setBulkUndeploySuccess,
    isUnsubscribeFlow,
  } = props;

  const sampleImage = snapshot;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const roiReducerList = useSelector((state) => state.deviceReducer.roiList);
  const sitetagList = useSelector((state) => state.sitesReducer.siteTagList);
  const { width: viewportWidth } = useWindowSize();
  const isSmallScreen = (viewportWidth ?? 1400) < parseInt(breakpoints.tablet);
  const [hoverStyleButton, setHoverStyleButton] = useState(null);
  const [hoverStyleButtonName, setHoverStyleButtonName] = useState(null);
  const [showCvAppsModal, setShowCvAppsModal] = useState(false);
  const [selectedAppTitleName, setSelectedAppTitleName] = useState(null);
  const [selectedAppId, setSelectedAppId] = useState([]);
  const [undeployBannerNotification, setUndeployBannerNotification] =
    useState(false);
  const [appsForBulkUndeployList, setAppsForBulkUndeployList] = useState([]);
  const roiListItem = useSelector((state) => state.polygonRoiReducer?.roiListWithCvapps?.filter(isRoiWithDeployedStatus));
  const [loading, setLoading] = useState(true);
  const [allimageList, setAllimageList] = useState([]);
  let [renderROIList, setRenderROIList] = useState(0);
  const cvAppNames = useSelector((state) => state.cvAppReducer.cvAppList);

  useEffect(() => {
    setAllimageList([]);
    setLoading(false);
  }, [filteredAppList]);

  const showLicenseSuspendedBanner = () => {
    const notificationInfo = {
      type: BANNER_TYPES.INFORMATION,
      priority: BANNER_TYPES.WARNING,
      showNotification: true,
      title: LICENSE_NOTIFICATION_TYPES.LICENSE_SUSPENDED,
      subtitle: LICENSE_NOTIFICATION_MESSAGES.LICENSE_SUSPENDED_MESSAGE,
    };
    dispatch(showNotificationBanner(notificationInfo));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onClickOfIcon = (
    e,
    val,
    id,
    name,
    polygonPoints,
    frame,
    pname,
    cvappid,
    cvAppCategory,
    deployments,
    tagsIds
  ) => {
    const maxX = frame?.polygon?.frame?.maxX
      ? frame?.polygon?.frame?.maxX
      : frame?.polygon?.polygon?.frame?.maxX ??
        frame?.polygon?.polygon?.frame?.maxX;
    const maxY = frame?.polygon?.frame?.maxY
      ? frame?.polygon?.frame?.maxY
      : frame?.polygon?.polygon?.frame?.maxY ??
        frame?.polygon?.polygon?.frame?.maxY;
    const roi = {
      groupName: FOVName,
      cvAppName: name,
      points: adjustPolygonPoints([maxX, maxY], polygonPoints, [832, 532]),
      originalPoints:
        polygonPoints && polygonPoints.length >= 3 ? polygonPoints : [],
      roiId: id,
      frame: frame,
      name: pname,
      cvappid: cvappid,
      category: cvAppCategory,
      deployments: deployments,
      fovObj: val,
      selectedCameraQR: val?.cameraId,
      companionSelected: val?.companionId,
    };
    const roiReducer = roiReducerList?.find((f) => f.id == id);
    var tagObject = [];
    const tagids = roiReducer?.tagids != undefined ? roiReducer?.tagids : [];
    if (
      roi?.cvAppName != CVAPP_OBJECTBLUR ||
      roi?.cvAppName != CVAPP_CAMERAADJUSTMENT
    ) {
      tagids.forEach((tag) => {
        tagObject = [
          ...tagObject,
          ...sitetagList.floors.filter((f) => {
            return f.id == tag;
          }),
        ];
        tagObject = [
          ...tagObject,
          ...sitetagList.areas.filter((f) => {
            return f.id == tag;
          }),
        ];
        tagObject = [
          ...tagObject,
          ...sitetagList.subareas.filter((f) => {
            return f.id == tag;
          }),
        ];
      });
    }

    const tagNames = tagObject.map((m) => {
      return m?.name;
    });
    roiIds.push(id);
    if (roiData.length > 0) {
      roiData.length = 0;
      roiData.push(roi);
    } else {
      roiData.push(roi);
    }
    // roiData.push(roi);
    selectedRoi.push({
      title: FOVName,
      value: name,
      floorImage: sampleImage,
      cvappid: cvappid,
      roiId: id,
      category: cvAppCategory,
      tagids: tagsIds,
      sitenames: tagNames,
      groupName: "ROI1-" + FOVName + "-" + name,
      deployments: deployments,
    });

    setRoiIds(roiIds);
    setRoiData(roiData);
    setSelectedRoi(selectedRoi);
  };

  const handleDeleteSelectedRoi = (e, selectedRoi) => {
    onDelete(selectedRoi);
  };

  const handleBulkUndeployOfCv = (appName, appList) => {
    setUndeployBannerNotification(true);
    if (!hasPermission("Apps", "Delete")) {
      showPermissionsBanner();
    } else {
      setShowCvAppsModal(true);
      setSelectedAppTitleName(appName);
      setSelectedAppId([appList[0].cvappid]);
      var appsForBulkUndeploy = [];
      [...filteredAppList].map(([name, imageList]) => {
        imageList.map((item) => {
          appList.map((val) => {
            if (item.cvappid === val.cvappid) {
              if (!appsForBulkUndeploy.some((i) => i.id === item.id)) {
                const appObj = {
                  id: item?.id,
                  cvappid: item?.cvappid,
                  deploymentId: item?.deployments[0]?.id,
                  deploymentStatus: item?.deployments[0]?.status,
                  deployments: item?.deployments,
                };
                appsForBulkUndeploy.push(appObj);
              }
            }
          });
        });
      });
      setAppsForBulkUndeployList(appsForBulkUndeploy);
    }
  };

  const handleCloseModal = () => {
    setShowCvAppsModal(false);
    setShowModal({
      isOpen: false,
    });
    setDeleteBannerNotification(false);
  };

  const isImageURL = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true); // Image loaded successfully
      img.onerror = () => resolve(false); // Image failed to load
      img.src = url;
    });
  };
  //let renderROIList = 0;
  const updateSnapshot = (url) => {
    setFloorImage(url);
    if (isImageURL(url)) {
      setLoading(false);
    } else {
      setLoading(true);
    }
    setRenderROIList(renderROIList);
  };
  const handleDeleteRoi = (roisId, cvappId, fromBulkUndeploy = false) => {
    showLoader(true);
    // Reset roiDeleteResponse before delete so the saga's response triggers the parent's useEffect
    let payload = {
      accountname: activeSession?.accountId,
      resourceidentifier: {
        deviceid: roiIds[0] || roisId,
      },
      appid: roiData[0]?.cvappid || cvappId,
    };
    const cvApp = roiData.find(f => f.roiId === roiIds[0]);
    if (cvApp && (cvApp.cvAppName === CVAPP_OBJECTBLUR || cvApp.cvAppName === CVAPP_CAMERAADJUSTMENT)) {
      const deploymentIds = selectedRoi[0]?.deployments?.filter(
        (d) => d.appid === selectedRoi[0]?.cvappid && deploymentstatusList.includes(d.status)
      );
      if (deploymentIds && deploymentIds.length > 0) {
        deploymentIds.map((item) => {
          payload.deploymentIds = item?.id;
          dispatch(unsubscribeObjectBlurringRoiRequest(payload, cvApp.cvAppName));
        });
      }
    } else {
      if (fromBulkUndeploy) {
        dispatch(deleteBulkUnsubscribeRoiRequest(payload));
      } else {
        const rois = [];
        rois.push({ cvappid: roiData[0]?.cvappid || cvappId, roiId: roiIds[0] || roisId });
        setRoiData(rois);
        dispatch(successDeleteRoi([])); //clean up the previous delete roi response
        dispatch(deleteRoiRequest(payload));
      }
    }
    setShowModal({
      isOpen: false,
    });
  };

  const imageSize = {
    width: 280,
    height: 180,
  };

  const handlePolygon = (
    val,
    id,
    name,
    cvappid,
    roiName,
    cvAppCategory,
    deployments,
    tagIds
  ) => {
    const polygonPoints = transformPolygonData(val);
    return (
      <React.Fragment key={id}>
        <li
          style={{
            listStyleType: "none",
            paddingRight: "28px",
            marginTop: "20px",
            marginBottom: "15px",
          }}
        >
          <div
            onMouseEnter={() => {
              setHoverStyleButton(id);
              setHoverStyleButtonName(name);
            }}
            onMouseLeave={() => {
              setHoverStyleButton(null);
              setHoverStyleButtonName(null);
            }}
            style={{ position: "relative", display: "inline-block" }}
          >
            {loading && (
              <Loader fullscreen={false} active={true} surface="light" />
            )}
            <div
              style={{
                filter:
                  !isSmallScreen && 
                  !isUnsubscribeFlow &&
                  hoverStyleButton === id && hoverStyleButtonName === name
                    ? "brightness(40%)"
                    : "brightness(100%)",
              }}
            >
              <SnapshotComponent
                editFlow={true}
                fovObj={val}
                selectedCameraQR={val?.cameraId}
                companionSelected={val?.companionId}
                imageSize={imageSize}
                initialPolygons={polygonPoints}
                originalSize={[val, val]}
                component={DisplayCanvas}
                handleChange={updateSnapshot}
              />
            </div>

            {(isSmallScreen || (hoverStyleButton === id && hoverStyleButtonName === name)) && !isUnsubscribeFlow && (
              <div className="roi-image-button-container">
                <StyledIconsET
                  data-testid="roiList_editIcon"
                  onClick={(e) => {
                    onClickOfIcon(
                      e,
                      val,
                      id,
                      name,
                      polygonPoints,
                      val,
                      roiName,
                      cvappid,
                      cvAppCategory,
                      deployments,
                      tagIds
                    );
                    if (selectedRoi) {
                      onEdit(selectedRoi);
                    }
                  }}
                >
                  <Icon name="edit" size="medium" ariaHidden={true} />
                </StyledIconsET>
                <StyledIconsET
                  data-testid="roiList_trashIcon"
                  onClick={(e) => {
                    onClickOfIcon(
                      e,
                      val,
                      id,
                      name,
                      polygonPoints,
                      val,
                      roiName,
                      cvappid,
                      cvAppCategory,
                      deployments
                    );
                    handleDeleteSelectedRoi(e, selectedRoi);
                  }}
                >
                  <Icon name="trash" size="medium" ariaHidden={true} />
                </StyledIconsET>
              </div>
            )}
          </div>
          <Tooltip title={roiName}>
            <TextEllipsis className="roi-image-description" width={`${imageSize.width}px`}>{roiName}</TextEllipsis>
          </Tooltip>
        </li>
      </React.Fragment>
    );
  };

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const handleAddRoiFunction = (title, cvappdata) => {
    dispatch(clearAdvancedConfigAppearances());
    if (isLicenseSuspended) {
      showLicenseSuspendedBanner();
      return;
    }
    if (!hasPermission("Apps", "Create")) {
      showPermissionsBanner();
    } else {
      const selectedCVApps = [
        {
          title: activeFOVTab.fovName,
          value: title,
          floorImage: sampleImage,
          cvappid: cvappdata?.[0]?.cvappid,
          category: cvappdata?.[0]?.category,
        },
      ];
      dispatch(resetRoi());
      const selectedState = {
        cvapps: selectedCVApps,
        FOVId: activeFOVTab.fovId,
        cameraId: cameraData.id,
        companionId: cameraData.parentdeviceid,
        cameraData: cameraData,
        streamData: streamData,
        fieldOfViews: fieldOfViews,
        FOVSnapshot: FOVSnapshot,
        location: "roilist",
        action: "create",
        // getActiveLicenseSku picks the primary SKU; add-ons (e.g. EA) are excluded.
        sku: streamData?.length > 0 ? getActiveLicenseSku(streamData[0]?.licenses) : "",
        originPage: state?.originPage ? state?.originPage : "",
      };
      navigate("/polygon", { state: selectedState });
    }
  };

  const handleBulkUndeploy = async () => {
    setShowCvAppsModal(false);
    showLoader(true);
      const undeployStatus = await cvAppBulkUndeployApi(
        selectedAppId,
        activeFOVTab.fovId,
        activeSession
      );
      const rois = [];
      if (undeployStatus === 200 && undeployBannerNotification) {
        setBulkUndeploySuccess(true);
        appsForBulkUndeployList.map((item) => {
          const app = cvAppNames.find(f => f.id === item?.cvappid);
          const dep = item?.deployments.find(f => deploymentstatusList.includes(f.status));

          if (app && (app.name === CVAPP_OBJECTBLUR || app.name === CVAPP_CAMERAADJUSTMENT)) {
            if (dep?.status === DEPLOYMENT_STATUS.DEPLOYED) {
              if (app.name === CVAPP_CAMERAADJUSTMENT) {
                // Fire and forget — undeploy already done, deleteBulkRule handles errors internally
                (async () => {
                  const rulesPayload = {
                    accountname: activeSession.accountId,
                    filter: { $selection: { deviceid: item?.id } }
                  };
                  const rules = await getRulesByDeviceId(rulesPayload);
                  if (rules && Array.isArray(rules)) {
                    const ruleIds = rules.map((m) => m.id);
                    if (ruleIds.length > 0) {
                      deleteBulkRule(activeSession, ruleIds);
                    }
                  }
                })();
              }
              return;
            }
            // Non-deployed states (undeploy_failed, updating, update_failed etc)
            const payload = {
              accountname: activeSession?.accountId,
              resourceidentifier: { deviceid: item?.id },
              appid: item?.cvappid,
              deploymentIds: dep?.id,
            };
            dispatch(unsubscribeObjectBlurringRoiRequest(payload, app.name));
            return;
          }

          rois.push({"cvappid": item?.cvappid, "roiId": item?.id});
          handleDeleteRoi(item?.id, item?.cvappid, true);
        });
        setRoiData(rois);
        if (state?.originPage === ORIGIN_PAGES.CV_APP_SUB) {
          // Unsubscribe flow: keep the loader on and let the parent useEffect decide the banner + navigation 
          setDeleteBannerNotification(true);
        } else {
          refreshRoi(true); // Call list API once after all bulk deletes
          const notificationInfo = {
            type: ROI_NOTIFICATION_TYPES.UNDEPLOY_CV_APP,
            priority: "success",
            data: {
              title: UNSUBSCRIBE_FLOW_TEXTS.UNDEPLOY_SUCCESS,
              subTitle: "",
            },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
        }
      } else {
        const notificationInfo = {
          type: ROI_NOTIFICATION_TYPES.UNDEPLOY_FAILED,
          priority: "critical",
          data: {
            title: UNSUBSCRIBE_FLOW_TEXTS.UNDEPLOY_FAILURE,
          },
          showNotification: true,
        };
        setBulkUndeploySuccess(false);
        dispatch(showNotificationBanner(notificationInfo));
        showLoader(false);
      }
  };
  return (
    <>
      <div className="roiBodySection">
        {filteredAppList?.size > 0 &&
          [...filteredAppList].map(([name, imageList], index) => {
            return (
              <div
                className="roi-app-card"
                key={index}
              >
                <div className="roi-app-header">
                  <div className="roi-app-title-group">
                    <Title
                      size="small"
                      color="#000000"
                      primitive="h2"
                      viewport="desktop"
                    >
                      <span className="roi-app-label">App:</span>
                      {name}
                    </Title>
                  </div>
                  <div
                    className="roi-app-trash-icon"
                    data-testid="roiList_trashIcon"
                    onClick={() => {
                      handleBulkUndeployOfCv(name, imageList);
                    }}
                  >
                    <Icon name="trash" size="medium" />
                  </div>
                </div>
                <div>
                  <ul
                    className="roiListElements"
                    style={{
                      width: "auto",
                      margin: "5px 5px 0 0",
                      overflow: "auto",
                    }}
                  >
                    {imageList.map((item) => {
                      if (!allimageList.includes(item)) {
                        setAllimageList((prevObjects) => [
                          ...prevObjects,
                          item,
                        ]);
                      }
                      return handlePolygon(
                        item,
                        item.id,
                        name,
                        item?.cvappid,
                        item?.roiName,
                        item?.category,
                        item?.deployments,
                        item?.tagIds
                      ); //pass id
                    })}
                    {!isUnsubscribeFlow &&
                      name != CVAPP_OBJECTBLUR &&
                      name != CVAPP_CAMERAADJUSTMENT && (
                        <StyledPlusIconDiv
                          data-testid="roiList_addRoiPlusIcon"
                          onClick={() => {
                            handleAddRoiFunction(name, imageList);
                          }}
                        >
                          <div style={{ margin: "auto 0px auto 13px" }}>
                            <StyledIcon
                              name="plus"
                              size="medium"
                              color="#000000"
                            />
                          </div>
                        </StyledPlusIconDiv>
                      )}
                  </ul>
                </div>
              </div>
            );
          })}
      </div>
      <Modal
        opened={showModal.isOpen}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        surface="light"
        fullScreenDialog={false}
        disableAnimation={false}
        disableOutsideClick={true}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
            data-testid="roiList_modalCloseIcon"
            onClick={handleCloseModal}
          >
            <Icon name="close" />
          </div>
        }
      >
        <ModalTitle>Delete Region of Interest</ModalTitle>
        <ModalBody>
          {roiData && roiData.length && (
            <div
              style={{
                paddingBottom: "5px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {snapshot && (
                <DisplayCanvas
                  imageSize={imageSize}
                  initialPolygons={roiData[0]?.originalPoints}
                  originalSize={[roiData[0]?.fovObj, roiData[0]?.fovObj]}
                  videoSource={snapshot}
                />
              )}
            </div>
          )}
          Are you sure you’d like to delete this region of interest? If yes, you
          will no longer receive{" "}
          {roiData && roiData.length && roiData[0]?.cvAppName} alerts or
          analytics in this region.
        </ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              width: "100%",
              children: "No, cancel",
              "data-testid": "roiList_noCancelButton",
              onClick: () => handleCloseModal(),
            },
            close: {
              width: "100%",
              children: "Yes, delete",
              "data-testid": "roiList_yesDeleteButton",
              onClick: () => {
                handleDeleteRoi();
              },
            },
          }}
        />
      </Modal>
      <Modal
        opened={showCvAppsModal}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        surface="light"
        fullScreenDialog={false}
        disableAnimation={false}
        disableOutsideClick={true}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
            data-testid="roiList_closeIcon"
            onClick={handleCloseModal}
          >
            <Icon name="close" />
          </div>
        }
      >
        <Notification
          type="warning"
          hideCloseButton={true}
          title="Unsubscribe to app"
          subtitle="Unsubscribing will delete any alerts or statistics associated with this app going forward."
        />
        <ModalBody>
          Are you sure you want to unsubscribe to the{" "}
          <b>{selectedAppTitleName}</b> app on{" "}
          <b>
            {cameraData?.name} , {FOVName}
          </b>
          ?
        </ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              width: "100%",
              children: "Cancel",
              "data-testid": "roiList_cancelButton",
              onClick: () => handleCloseModal(),
            },
            close: {
              width: "100%",
              children: "Submit",
              "data-testid": "roiList_submitButton",
              onClick: () => {
                handleBulkUndeploy(
                  selectedAppId,
                  activeFOVTab.fovId,
                  activeSession
                );
                setBulkUndeploySuccess(false);
              },
            },
          }}
        />
      </Modal>
    </>
  );
};

export default RoiList;
